export const isNullCoords = (value?: [number | null, number | null] | null) => {
  if (!value) {return true;}
  const [lng, lat] = value;
  if (!lng || !lat) {return true;}

  return false;
};
